import './App.css';
import ClickSync from './ClickSync';
import BackbonePanel from './BackbonePanel';

function App() {
  return (
    <div className="App">
      <BackbonePanel />
      <div className="main-game">
        <ClickSync />
      </div>
    </div>
  );
}

export default App;
